import { render } from "./ResumeIcon.vue?vue&type=template&id=b569e7ce&scoped=true"
import script from "./ResumeIcon.vue?vue&type=script&lang=js"
export * from "./ResumeIcon.vue?vue&type=script&lang=js"

import "./ResumeIcon.vue?vue&type=style&index=0&id=b569e7ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b569e7ce"]])

export default __exports__